// extracted by mini-css-extract-plugin
module.exports = {"mt4":"style_mt4__rABi_","mt8":"style_mt8__f4f27","ml4":"style_ml4__1dQW5","spacer":"style_spacer__aInPj"};